"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslatedImage = exports.LwtI18nProvider = exports.getSpecificTranslation = exports.getLocale = exports.setLocale = exports.tA11y = exports.translate = exports.initI18n = void 0;
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const types_1 = require("../../types");
const dom_util_1 = __importDefault(require("./dom-util"));
const a11ySettings_json_1 = __importDefault(require("../../assets/translations/en-US/a11ySettings.json"));
const a11ySettings_json_2 = __importDefault(require("../../assets/translations/es-US/a11ySettings.json"));
const initI18n = ({ resourceMap = {}, i18nOptions = {} } = {}) => {
    i18next_1.default.use(react_i18next_1.initReactI18next).init(Object.assign({ lng: types_1.Locale.EN_US, keySeparator: '.', supportedLngs: [types_1.Locale.ES_US, types_1.Locale.EN_US], interpolation: {
            escapeValue: false
        }, resources: {
            [types_1.Locale.EN_US]: {
                translation: Object.assign({ 'lwt-lib-a11ySettings': a11ySettings_json_1.default }, resourceMap[types_1.Locale.EN_US])
            },
            [types_1.Locale.ES_US]: {
                translation: Object.assign({ 'lwt-lib-a11ySettings': a11ySettings_json_2.default }, resourceMap[types_1.Locale.ES_US])
            }
        } }, i18nOptions));
    return i18next_1.default;
};
exports.initI18n = initI18n;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const translate = (namespace, key, options) => {
    const trans = i18next_1.default.t(`${namespace}.${key}`, options);
    return trans;
};
exports.translate = translate;
const tA11y = (key, options) => {
    return i18next_1.default.t(`a11y.${key}`, options);
};
exports.tA11y = tA11y;
const setLocale = (locale) => {
    i18next_1.default.changeLanguage(locale);
    dom_util_1.default.changeLanguage(locale);
};
exports.setLocale = setLocale;
const getLocale = () => {
    return i18next_1.default.language;
};
exports.getLocale = getLocale;
const getSpecificTranslation = (locale, namespace, text, options) => {
    const translateForLocale = i18next_1.default.getFixedT(locale, namespace);
    return translateForLocale(text, options);
};
exports.getSpecificTranslation = getSpecificTranslation;
exports.LwtI18nProvider = react_i18next_1.I18nextProvider;
const getTranslatedImage = (imageName) => {
    var _a;
    const locale = exports.getLocale();
    return (_a = require(`../../assets/translatedImages/${locale}/${imageName}`)) !== null && _a !== void 0 ? _a : '';
};
exports.getTranslatedImage = getTranslatedImage;
